import { render, staticRenderFns } from "./clubCreate.vue?vue&type=template&id=57c0b764&"
import script from "./clubCreate.vue?vue&type=script&lang=js&"
export * from "./clubCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports